import { Button } from '@/modules/shared/components/ui/button';
import { Alert, AlertDescription } from '@/modules/shared/components/ui/alert';

interface ErrorDisplayProps {
  message: string;
  onRetry?: () => void;
  retryText?: string;
}

export function ErrorDisplay({ message, onRetry, retryText = 'Try Again' }: ErrorDisplayProps) {
  return (
    <div className="rounded-lg border border-destructive/20 bg-destructive-soft p-8 text-center text-destructive dark:border-destructive/30 dark:bg-destructive/10 dark:text-destructive">
      <Alert className="border-destructive/20 bg-destructive-soft dark:border-destructive/30 dark:bg-destructive/10">
        <AlertDescription className="text-destructive">
          {message}
        </AlertDescription>
      </Alert>
      {onRetry && (
        <Button 
          variant="outline"
          onClick={onRetry} 
          className="mt-4"
        >
          {retryText}
        </Button>
      )}
    </div>
  );
}